import type { ComputedRef, InjectionKey, Ref } from 'vue'
import type {
  CustomField,
  FieldConfig,
  FieldOrigin
} from '../FieldConfiguration'
import type {
  AddCustomFieldRequestPayload,
  UpdateCustomFieldRequestPayload,
  SetFieldConfigRequestPayload
} from '../api-requests/FieldConfigurationRequests'
import type {
  ResolvedField,
  SystemFieldDefinition
} from '../CustomFieldDefinitions'

/**
 * Contract for the custom-fields admin-CRUD datasource
 * (`useCustomFieldsAdmin` in `@gat-ship/custom-fields`). Runtime-free —
 * SignalR subscribe/unsubscribe handles are consumed internally and not
 * exposed, so there is nothing to omit here.
 */
export interface CustomFieldsAdminService {
  loading: Ref<boolean>
  loadingFieldIds: Ref<Set<string>>
  systemFields: ComputedRef<SystemFieldDefinition[]>
  customFields: Ref<CustomField[]>
  fieldConfigs: Ref<FieldConfig[]>
  resolvedFields: ComputedRef<ResolvedField[]>
  load(): Promise<void>
  addCustomField(payload: AddCustomFieldRequestPayload): Promise<void>
  updateCustomField(
    id: string,
    payload: UpdateCustomFieldRequestPayload
  ): Promise<void>
  deleteCustomField(id: string): Promise<void>
  reorderCustomFields(orderedIds: string[]): Promise<void>
  setFieldConfig(
    origin: FieldOrigin,
    fieldName: string,
    payload: SetFieldConfigRequestPayload
  ): Promise<void>
  resetFieldConfig(origin: FieldOrigin, fieldName: string): Promise<void>
}

export const customFieldsAdminKey = Symbol(
  'gs-custom-fields-admin'
) as InjectionKey<CustomFieldsAdminService>
